// layout
import layoutHeaderAside from '@/layout/header-aside';

const meta = { requiresAuth: true };

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: { name: 'index',path:'/' },
    component: layoutHeaderAside,
    children: [
      {
        path: 'index',
        name: 'index',
        meta,
        component: () => import('@/pages/index')
      }
    ]
  },
  // 培训管理
  {
    path: '/train',
    name: 'train',
    meta,
    redirect: { name: 'train-single' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'group',
        name: `${pre}group`,
        component: () => import('@/pages/train/group'),
        meta: { ...meta, title: '培训组管理' }
      },
      {
        path: 'class-adjust',
        name: `${pre}class-adjust`,
        component: () => import('@/pages/train/classAdjust'),
        meta: { ...meta, title: '分班调班', hidden: true }
      },
      {
        path: 'single',
        name: `${pre}single`,
        component: () => import('@/pages/train/single'),
        meta: { ...meta, title: '分级单次培训' }
      },
      {
        path: 'single-upgrade',
        name: `${pre}single-upgrade`,
        component: () => import('@/pages/train/singleUpgrade'),
        meta: { ...meta, title: '分级升级培训' }
      },
      {
        path: 'all',
        name: `${pre}all`,
        component: () => import('@/pages/train/all'),
        meta: { ...meta, title: '分级整期培训' }
      },
      {
        path: 'juvenile',
        name: `${pre}juvenile`,
        component: () => import('@/pages/train/juvenile'),
        meta: { ...meta, title: '青少年儿童培训' }
      },
      {
        path: 'custom/personage',
        name: `${pre}personage`,
        component: () => import('@/pages/train/custom/personage'),
        meta: { ...meta, title: '个人培训' }
      },
      {
        path: 'custom/group',
        name: `${pre}group`,
        component: () => import('@/pages/train/custom/group'),
        meta: { ...meta, title: '团体培训' }
      },
      {
        path: 'attendance',
        name: `${pre}attendance`,
        component: () => import('@/pages/train/attendance'),
        meta: { ...meta, title: '考勤表管理' }
      },
      {
        path: 'vacate',
        name: `${pre}vacate`,
        component: () => import('@/pages/train/vacate'),
        meta: { ...meta, title: '请假管理' }
      },
      {
        path: 'coach',
        name: `${pre}coach`,
        component: () => import('@/pages/train/coach'),
        meta: { ...meta, title: '教练管理' }
      },
      {
        path: 'reserveCoach',
        name: `${pre}reserveCoach`,
        component: () => import('@/pages/train/coach/reserveCoach'),
        meta: { ...meta, title: '约教练管理' }
      },
      {
        path: 'evaluation',
        name: `${pre}evaluation`,
        redirect: { name: `${pre}archive-student` },
        meta: { ...meta, title: '学员技术诊断' }
      },
      {
        path: 'archive/student',
        name: `${pre}archive-student`,
        component: () => import('@/pages/train/archive/student'),
        meta: { ...meta, title: '学员成长档案' }
      },
      {
        path: 'archive/evaluation',
        name: `${pre}archive-evaluation`,
        component: () => import('@/pages/train/archive/evaluation'),
        meta: { ...meta, title: '评价记录' }
      },
      {
        path: 'trainVacate',
        name: `${pre}trainVacate`,
        component: () => import('@/pages/train/trainVacate'),
        meta: { ...meta, title: '培训请假管理' }
      },
      {
        path: 'course',
        name: `${pre}course`,
        component: () => import('@/pages/train/course'),
        meta: { ...meta, title: '课程管理', hidden: true }
      }
    ])('train-')
  },
  // 财务管理
  {
    path: '/finance',
    name: 'finance-competitionOrder',
    meta,
    redirect: { name: 'finance-competitionOrder-classification' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'competitionOrder/classification',
        name: `${pre}classification`,
        component: () =>
          import('@/pages/finance/competitionOrder/classification'),
        meta: { ...meta, title: '分级公开赛订单' }
      },
      {
        path: 'competitionOrder/YouthCompetition',
        name: `${pre}YouthCompetition`,
        component: () =>
          import('@/pages/finance/competitionOrder/YouthCompetition'),
        meta: { ...meta, title: '青少年公开赛订单' }
      },
      {
        path: 'competitionOrder/club',
        name: `${pre}club`,
        component: () => import('@/pages/finance/competitionOrder/club'),
        meta: { ...meta, title: '俱乐部公开赛订单' }
      },
      {
        path: 'competitionOrder/reserveSite',
        name: `${pre}reserveSite`,
        component: () =>
          import('@/pages/finance/competitionOrder/reserverSite'),
        meta: { ...meta, title: '约场地订单' }
      },
      //6.27@lrq
      {
        path: 'competitionOrder/self',
        name: `${pre}self`,
        component: () =>
          import('@/pages/finance/competitionOrder/self'),
        meta: { ...meta, title: '自助约赛订单' }
      },
      {
        path: 'competitionOrder/coach',
        name: `${pre}coach`,
        component: () => import('@/pages/finance/competitionOrder/coach'),
        meta: { ...meta, title: '约教练订单' }
      },
      {
        path: 'refundManage/reserveSiteRefound',
        name: `${pre}reserveSiteRefound`,
        component: () =>
          import('@/pages/finance/refundManage/reserveSiteRefund'),
        meta: { ...meta, title: '约场地退款' }
      },
      {
        path: 'refundManage/coachRefund',
        name: `${pre}coachRefund`,
        component: () => import('@/pages/finance/refundManage/coachRefund'),
        meta: { ...meta, title: '约教练退款' }
      },
      {
        path: 'refundManage/competitionRefund',
        name: `${pre}competitionRefund`,
        component: () =>
          import('@/pages/finance/refundManage/competitionRefund'),
        meta: { ...meta, title: '竞赛退款' }
      },
      {
        path: 'refundManage/trainRefund',
        name: `${pre}trainRefund`,
        component: () => import('@/pages/finance/refundManage/trainRefund'),
        meta: { ...meta, title: '培训退款' }
      },
      {
        path: 'trainOrder/singleOrder',
        name: `${pre}singleOrder`,
        component: () => import('@/pages/finance/trainOrder/singleOrder'),
        meta: { ...meta, title: '单次培训订单' }
      },
      {
        path: 'trainOrder/singleUpgradeOrder',
        name: `${pre}singleUpgradeOrder`,
        component: () => import('@/pages/finance/trainOrder/singleUpgradeOrder'),
        meta: { ...meta, title: '分级升级培训订单' }
      },
      {
        path: 'trainOrder/allOrder',
        name: `${pre}allOrder`,
        component: () => import('@/pages/finance/trainOrder/allOrder'),
        meta: { ...meta, title: '整期培训订单' }
      },
      {
        path: 'trainOrder/juvenileOrder',
        name: `${pre}juvenileOrder`,
        component: () => import('@/pages/finance/trainOrder/juvenileOrder'),
        meta: { ...meta, title: '青少年儿童培训订单' }
      },
      {
        path: 'trainOrder/customOrder',
        name: `${pre}customOrder`,
        component: () => import('@/pages/finance/trainOrder/customOrder'),
        meta: { ...meta, title: '定制化培训订单' }
      },
      {
        path: 'trainOrder/order',
        name: `${pre}order`,
        component: () => import('@/pages/finance/trainOrder/order'),
        meta: { ...meta, title: '培训订单与销课' }
      },
      {
        path: 'joinFee/feetable',
        name: `${pre}feetable`,
        component: () => import('@/pages/finance/joinFee/feetable'),
        meta: { ...meta, title: '费用表单' }
      }
    ])('finance-competitionOrder-')
  },
  {
    path: '/msg',
    name: 'msg',
    meta,
    redirect: { name: 'msg-manage' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'manage',
        name: `${pre}manage`,
        component: () => import('@/pages/msg/manage'),
        meta: { ...meta, title: '消息管理' }
      }
    ])('msg-')
  },
  // 预约场地
  {
    path: '/reserveSite',
    name: 'reserveSite',
    meta,
    redirect: { name: 'reserveSite-site' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'site',
        name: `${pre}site`,
        component: () => import('@/pages/reserveSite/index'),
        meta: { ...meta, title: '约场地管理' }
      }
    ])('reserveSite-')
  },
  // 运营
  {
    path: '/operation',
    name: 'operation',
    meta,
    redirect: { name: 'operation-place' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'place',
        name: `${pre}place`,
        component: () => import('@/pages/operation/place'),
        meta: { ...meta, title: '场馆管理' }
      },
      {
        path: 'joinSet',
        name: `${pre}joinSet`,
        component: () => import('@/pages/operation/joinSet'),
        meta: { ...meta, title: '加盟费配置' }
      },
      // {
      //   path: 'limitSet',
      //   name: `${pre}limitSet`,
      //   component: () => import('@/pages/operation/limitSet'),
      //   meta: { ...meta, title: '限额配置' }
      // },
      {
        path: 'fee',
        name: `${pre}fee`,
        component: () => import('@/pages/operation/fee'),
        meta: { ...meta, title: '费用管理' }
      },
      {
        path: 'score',
        name: `${pre}score`,
        component: () => import('@/pages/operation/score'),
        meta: { ...meta, title: '积分榜管理' }
      },
      {
        path: 'coupon',
        name: `${pre}coupon`,
        component: () => import('@/pages/operation/coupon'),
        meta: { ...meta, title: '代金券管理' }
      }
    ])('operation-')
  },
  {
    path: '/news',
    name: 'news',
    meta,
    redirect: { name: 'news-list' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'list',
        name: `${pre}list`,
        component: () => import('@/pages/news/list'),
        meta: { ...meta, title: '资讯列表' }
      },
      {
        path: 'rotary',
        name: `${pre}rotary`,
        component: () => import('@/pages/news/rotary'),
        meta: { ...meta, title: '轮播图管理' }
      },
      {
        path: 'logo',
        name: `${pre}logo`,
        component: () => import('@/pages/news/logo'),
        meta: { ...meta, title: 'LOGO墙管理' }
      },
      {
        path: 'partner',
        name: `${pre}partner`,
        component: () => import('@/pages/news/partner'),
        meta: { ...meta, title: '合作方管理' }
      },
      {
        path: 'msgBoard',
        name: `${pre}msgBoard`,
        component: () => import('@/pages/news/msgBoard'),
        meta: { ...meta, title: '留言板管理' }
      },
      {
        path: 'live',
        name: `${pre}live`,
        component: () => import('@/pages/news/live'),
        meta: { ...meta, title: '直播管理' }
      }
    ])('news-')
  },
  //统计
  {
    path: '/statical',
    name: 'statical',
    meta,
    redirect: { name: 'statical-competitionStatical' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'competitionStatical',
        name: `${pre}competitionStatical`,
        component: () => import('@/pages/statical/competitionStatical'),
        meta: { ...meta, title: '竞赛统计' }
      },
      {
        path: 'financeStatical',
        name: `${pre}financeStatical`,
        component: () => import('@/pages/statical/financeStatical'),
        meta: { ...meta, title: '财务统计' }
      },
      {
        path: 'trainStatical',
        name: `${pre}trainStatical`,
        component: () => import('@/pages/statical/trainStatical'),
        meta: { ...meta, title: '培训统计' }
      },
      {
        path: 'franchiseStatical',
        name: `${pre}franchiseStatical`,
        component: () => import('@/pages/statical/franchiseStatical'),
        meta: { ...meta, title: '加盟费统计' }
      },
      {
        path: 'franchiseOrgStatical',
        name: `${pre}franchiseOrgStatical`,
        component: () => import('@/pages/statical/franchiseOrgStatical'),
        meta: { ...meta, title: '加盟商加盟费统计' }
      }
    ])('statical-')
  },
  // 系统管理
  {
    path: '/sys',
    name: 'sys',
    meta,
    redirect: { name: 'sys-org' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'org',
        name: `${pre}org`,
        component: () => import('@/pages/sys/org'),
        meta: { ...meta, title: '主办方管理' }
      },
      {
        path: 'admin',
        name: `${pre}admin`,
        component: () => import('@/pages/sys/user'),
        meta: { ...meta, title: '用户管理' }
      },
      {
        path: 'role',
        name: `${pre}role`,
        component: () => import('@/pages/sys/role'),
        meta: { ...meta, title: '角色与权限管理' }
      },
      {
        path: 'menu',
        name: `${pre}menu`,
        component: () => import('@/pages/sys/menu'),
        meta: { ...meta, title: '菜单管理' }
      },
      {
        path: 'log',
        name: `${pre}log`,
        component: () => import('@/pages/sys/log'),
        meta: { ...meta, title: '日志管理' }
      },
      {
        path: 'setting/sql',
        name: `${pre}sql`,
        component: () => import('@/pages/sys/setting/sql'),
        meta: { ...meta, title: 'SQL监控' }
      },
      {
        path: 'setting/code',
        name: `${pre}code`,
        component: () => import('@/pages/sys/setting/code'),
        meta: { ...meta, title: '代码生成' }
      },
      {
        path: 'page-cache/off',
        name: `${pre}page-cache-off`,
        component: () => import('@/pages/demo/playground/page-cache/off.vue'),
        meta: { ...meta, title: '关闭缓存' }
      }
    ])('sys-')
  },
  // {
  //   path: '/sys/setting',
  //   name: 'sys-setting',
  //   meta,
  //   // redirect: { name: 'sys-setting' },
  //   component: layoutHeaderAside,
  //   children: (pre => [
  //     { path: 'sql', name: `${pre}sql`, component: () => import('@/pages/sys/setting/sql'), meta: { ...meta, title: 'SQL监控' } },
  //     { path: 'code', name: `${pre}code`, component: () => import('@/pages/sys/setting/code'), meta: { ...meta, title: '代码生成' } }
  //     { path: 'log', name: `${pre}log`, component: () => import('@/pages/sys/setting/log'), meta: { ...meta, title: '日志管理' } }
  //   ])('sys-setting-')
  // },
  {
    path: '/demo/playground',
    name: 'demo-playground',
    meta,
    redirect: { name: 'demo-playground-index' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'index',
        name: `${pre}index`,
        component: () => import('@/pages/demo/playground/index'),
        meta: { ...meta, title: '功能首页' }
      },
      {
        path: 'page-cache/on',
        name: `${pre}page-cache-on`,
        component: () => import('@/pages/demo/playground/page-cache/on.vue'),
        meta: { ...meta, title: '开启缓存' }
      },
      {
        path: 'page-cache/off',
        name: `${pre}page-cache-off`,
        component: () => import('@/pages/demo/playground/page-cache/off.vue'),
        meta: { ...meta, notCache: true, title: '关闭缓存' }
      },
      {
        path: 'page-argu/send',
        name: `${pre}page-argu-send`,
        component: () => import('@/pages/demo/playground/page-argu/send.vue'),
        meta: { ...meta, title: '参数传递 发送' }
      },
      {
        path: 'page-argu/get/:username',
        name: `${pre}page-argu-get`,
        component: () => import('@/pages/demo/playground/page-argu/get.vue'),
        meta: { ...meta, title: '参数传递 接收' }
      },
      {
        path: 'store/menu',
        name: `${pre}store-menu`,
        component: () => import('@/pages/demo/playground/store/menu'),
        meta: { ...meta, title: '菜单控制' }
      },
      {
        path: 'store/size',
        name: `${pre}store-size`,
        component: () => import('@/pages/demo/playground/store/size'),
        meta: { ...meta, title: '全局尺寸' }
      },
      {
        path: 'store/ua',
        name: `${pre}store-ua`,
        component: () => import('@/pages/demo/playground/store/ua'),
        meta: { ...meta, title: '浏览器信息' }
      },
      {
        path: 'store/gray',
        name: `${pre}store-gray`,
        component: () => import('@/pages/demo/playground/store/gray'),
        meta: { ...meta, title: '灰度模式' }
      },
      {
        path: 'store/fullscreen',
        name: `${pre}store-fullscreen`,
        component: () => import('@/pages/demo/playground/store/fullscreen'),
        meta: { ...meta, title: '全屏' }
      },
      {
        path: 'store/theme',
        name: `${pre}store-theme`,
        component: () => import('@/pages/demo/playground/store/theme'),
        meta: { ...meta, title: '主题' }
      },
      {
        path: 'store/transition',
        name: `${pre}store-transition`,
        component: () => import('@/pages/demo/playground/store/transition'),
        meta: { ...meta, title: '页面过渡开关' }
      },
      {
        path: 'db/all',
        name: `${pre}db-all`,
        component: () => import('@/pages/demo/playground/db/all'),
        meta: { ...meta, title: '总览' }
      },
      {
        path: 'db/public',
        name: `${pre}db-public`,
        component: () => import('@/pages/demo/playground/db/public'),
        meta: { ...meta, title: '公共存储' }
      },
      {
        path: 'db/user',
        name: `${pre}db-user`,
        component: () => import('@/pages/demo/playground/db/user'),
        meta: { ...meta, title: '私有存储' }
      },
      {
        path: 'db/page-public',
        name: `${pre}db-page-public`,
        component: () => import('@/pages/demo/playground/db/page-public'),
        meta: { ...meta, title: '路由存储' }
      },
      {
        path: 'db/page-user',
        name: `${pre}db-page-user`,
        component: () => import('@/pages/demo/playground/db/page-user'),
        meta: { ...meta, title: '私有路由存储' }
      },
      {
        path: 'db/page-snapshot-public',
        name: `${pre}db-page-snapshot-public`,
        component: () =>
          import('@/pages/demo/playground/db/page-snapshot-public'),
        meta: { ...meta, title: '路由快照' }
      },
      {
        path: 'db/page-snapshot-user',
        name: `${pre}db-page-snapshot-user`,
        component: () =>
          import('@/pages/demo/playground/db/page-snapshot-user'),
        meta: { ...meta, title: '私有路由快照' }
      },
      {
        path: 'log/log',
        name: `${pre}log-log`,
        component: () => import('@/pages/demo/playground/log/log'),
        meta: { ...meta, title: '日志记录' }
      },
      {
        path: 'log/error',
        name: `${pre}log-error`,
        component: () => import('@/pages/demo/playground/log/error'),
        meta: { ...meta, title: '错误捕捉' }
      },
      {
        path: 'log/console',
        name: `${pre}log-console`,
        component: () => import('@/pages/demo/playground/log/console'),
        meta: { ...meta, title: '控制台日志' }
      },
      {
        path: 'env',
        name: `${pre}env`,
        component: () => import('@/pages/demo/playground/env'),
        meta: { ...meta, title: '环境信息' }
      }
    ])('demo-playground-')
  },
  {
    path: '/demo/frame',
    name: 'demo-frame',
    meta,
    redirect: { name: 'demo-frame-index' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'd2-doc',
        name: `${pre}d2-doc`,
        component: () => import('@/pages/demo/frame/d2-doc'),
        meta: { ...meta, title: 'SuntrayAdmin 中文文档' }
      }
    ])('demo-frame-')
  },
  {
    path: '/demo/d2-crud',
    name: 'demo-d2-crud',
    meta,
    redirect: { name: 'demo-d2-crud-index' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'index',
        name: `${pre}index`,
        component: () => import('@/pages/demo/d2-crud/index'),
        meta: { ...meta, title: '表格组件 首页' }
      },
      {
        path: 'demo1',
        name: `${pre}demo1`,
        component: () => import('@/pages/demo/d2-crud/demo1'),
        meta: { ...meta, title: '基础表格' }
      },
      {
        path: 'demo2',
        name: `${pre}demo2`,
        component: () => import('@/pages/demo/d2-crud/demo2'),
        meta: { ...meta, title: '带斑马纹表格' }
      },
      {
        path: 'demo3',
        name: `${pre}demo3`,
        component: () => import('@/pages/demo/d2-crud/demo3'),
        meta: { ...meta, title: '带边框表格' }
      },
      {
        path: 'demo4',
        name: `${pre}demo4`,
        component: () => import('@/pages/demo/d2-crud/demo4'),
        meta: { ...meta, title: '带状态表格' }
      },
      {
        path: 'demo5',
        name: `${pre}demo5`,
        component: () => import('@/pages/demo/d2-crud/demo5'),
        meta: { ...meta, title: '固定表头' }
      },
      {
        path: 'demo6',
        name: `${pre}demo6`,
        component: () => import('@/pages/demo/d2-crud/demo6'),
        meta: { ...meta, title: '固定列' }
      },
      {
        path: 'demo7',
        name: `${pre}demo7`,
        component: () => import('@/pages/demo/d2-crud/demo7'),
        meta: { ...meta, title: '流体高度' }
      },
      {
        path: 'demo8',
        name: `${pre}demo8`,
        component: () => import('@/pages/demo/d2-crud/demo8'),
        meta: { ...meta, title: '多级表头' }
      },
      {
        path: 'demo9',
        name: `${pre}demo9`,
        component: () => import('@/pages/demo/d2-crud/demo9'),
        meta: { ...meta, title: '单选' }
      },
      {
        path: 'demo10',
        name: `${pre}demo10`,
        component: () => import('@/pages/demo/d2-crud/demo10'),
        meta: { ...meta, title: '多选' }
      },
      {
        path: 'demo11',
        name: `${pre}demo11`,
        component: () => import('@/pages/demo/d2-crud/demo11'),
        meta: { ...meta, title: '排序' }
      },
      {
        path: 'demo12',
        name: `${pre}demo12`,
        component: () => import('@/pages/demo/d2-crud/demo12'),
        meta: { ...meta, title: '筛选' }
      },
      {
        path: 'demo13',
        name: `${pre}demo13`,
        component: () => import('@/pages/demo/d2-crud/demo13'),
        meta: { ...meta, title: '表尾合计行' }
      },
      {
        path: 'demo14',
        name: `${pre}demo14`,
        component: () => import('@/pages/demo/d2-crud/demo14'),
        meta: { ...meta, title: '合并行' }
      },
      {
        path: 'demo15',
        name: `${pre}demo15`,
        component: () => import('@/pages/demo/d2-crud/demo15'),
        meta: { ...meta, title: '合并列' }
      },
      {
        path: 'demo16',
        name: `${pre}demo16`,
        component: () => import('@/pages/demo/d2-crud/demo16'),
        meta: { ...meta, title: '新增数据' }
      },
      {
        path: 'demo17',
        name: `${pre}demo17`,
        component: () => import('@/pages/demo/d2-crud/demo17'),
        meta: { ...meta, title: '修改数据' }
      },
      {
        path: 'demo18',
        name: `${pre}demo18`,
        component: () => import('@/pages/demo/d2-crud/demo18'),
        meta: { ...meta, title: '删除数据' }
      },
      {
        path: 'demo19',
        name: `${pre}demo19`,
        component: () => import('@/pages/demo/d2-crud/demo19'),
        meta: { ...meta, title: '自定义操作列' }
      },
      {
        path: 'demo20',
        name: `${pre}demo20`,
        component: () => import('@/pages/demo/d2-crud/demo20'),
        meta: { ...meta, title: '表单组件渲染' }
      },
      {
        path: 'demo21',
        name: `${pre}demo21`,
        component: () => import('@/pages/demo/d2-crud/demo21'),
        meta: { ...meta, title: '表单布局' }
      },
      {
        path: 'demo22',
        name: `${pre}demo22`,
        component: () => import('@/pages/demo/d2-crud/demo22'),
        meta: { ...meta, title: '表单校验' }
      },
      {
        path: 'demo23',
        name: `${pre}demo23`,
        component: () => import('@/pages/demo/d2-crud/demo23'),
        meta: { ...meta, title: '表格内编辑' }
      },
      {
        path: 'demo24',
        name: `${pre}demo24`,
        component: () => import('@/pages/demo/d2-crud/demo24'),
        meta: { ...meta, title: '表格slot' }
      },
      {
        path: 'demo25',
        name: `${pre}demo25`,
        component: () => import('@/pages/demo/d2-crud/demo25'),
        meta: { ...meta, title: '表格自定义组件' }
      },
      {
        path: 'demo26',
        name: `${pre}demo26`,
        component: () => import('@/pages/demo/d2-crud/demo26'),
        meta: { ...meta, title: '表单自定义组件' }
      },
      {
        path: 'demo27',
        name: `${pre}demo27`,
        component: () => import('@/pages/demo/d2-crud/demo27'),
        meta: { ...meta, title: '加载状态' }
      },
      {
        path: 'demo28',
        name: `${pre}demo28`,
        component: () => import('@/pages/demo/d2-crud/demo28'),
        meta: { ...meta, title: '自定义加载状态' }
      },
      {
        path: 'demo29',
        name: `${pre}demo29`,
        component: () => import('@/pages/demo/d2-crud/demo29'),
        meta: { ...meta, title: '分页' }
      }
    ])('demo-d2-crud-')
  },
  {
    path: '/demo/plugins',
    name: 'demo-plugins',
    meta,
    redirect: { name: 'demo-plugins-index' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'better-scroll/base',
        name: `${pre}better-scroll-base`,
        component: () => import('@/pages/demo/plugins/better-scroll/base.vue'),
        meta: { ...meta, title: '滚动插件基础' }
      },
      {
        path: 'better-scroll/to',
        name: `${pre}better-scroll-to`,
        component: () => import('@/pages/demo/plugins/better-scroll/to.vue'),
        meta: { ...meta, title: '滚动定位' }
      },
      {
        path: 'clipboard-polyfill',
        name: `${pre}clipboard-polyfill`,
        component: () => import('@/pages/demo/plugins/clipboard-polyfill'),
        meta: { ...meta, title: '剪贴板访问' }
      },
      {
        path: 'day',
        name: `${pre}day`,
        component: () => import('@/pages/demo/plugins/day'),
        meta: { ...meta, title: '日期计算' }
      },
      {
        path: 'export/table',
        name: `${pre}export-table`,
        component: () => import('@/pages/demo/plugins/export/table.vue'),
        meta: { ...meta, title: '导出表格' }
      },
      {
        path: 'export/txt',
        name: `${pre}export-txt`,
        component: () => import('@/pages/demo/plugins/export/txt.vue'),
        meta: { ...meta, title: '导出文本' }
      },
      {
        path: 'i18n/demo1',
        name: `${pre}i18n-demo1`,
        component: () => import('@/pages/demo/plugins/i18n/demo1.vue'),
        meta: { ...meta, title: '多国语示例 1' }
      },
      {
        path: 'i18n/demo2',
        name: `${pre}i18n-demo2`,
        component: () => import('@/pages/demo/plugins/i18n/demo2.vue'),
        meta: { ...meta, title: '多国语示例 2' }
      },
      {
        path: 'import/csv',
        name: `${pre}import-csv`,
        component: () => import('@/pages/demo/plugins/import/csv.vue'),
        meta: { ...meta, title: '导入 csv' }
      },
      {
        path: 'import/xlsx',
        name: `${pre}import-xlsx`,
        component: () => import('@/pages/demo/plugins/import/xlsx.vue'),
        meta: { ...meta, title: '导入 xlsx' }
      },
      {
        path: 'index',
        name: `${pre}index`,
        component: () => import('@/pages/demo/plugins/index'),
        meta: { ...meta, title: '插件首页' }
      },
      {
        path: 'js-cookie',
        name: `${pre}js-cookie`,
        component: () => import('@/pages/demo/plugins/js-cookie'),
        meta: { ...meta, title: 'Cookie' }
      },
      {
        path: 'mock/ajax',
        name: `${pre}mock-ajax`,
        component: () => import('@/pages/demo/plugins/mock/ajax.vue'),
        meta: { ...meta, title: '模拟数据' }
      },
      {
        path: 'mock/dpd',
        name: `${pre}mock-dpd`,
        component: () => import('@/pages/demo/plugins/mock/dpd.vue'),
        meta: { ...meta, title: 'mock dpd规则' }
      },
      {
        path: 'mock/dtd',
        name: `${pre}mock-dtd`,
        component: () => import('@/pages/demo/plugins/mock/dtd.vue'),
        meta: { ...meta, title: 'mock dtd规则' }
      }
    ])('demo-plugins-')
  },
  {
    path: '/demo/charts',
    name: 'demo-charts',
    meta,
    redirect: { name: 'demo-charts-index' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'index',
        name: `${pre}index`,
        component: () => import('@/pages/demo/charts/index'),
        meta: { ...meta, title: '图表首页' }
      },
      {
        path: 'list/line/demo1',
        name: `${pre}list-line-demo1`,
        component: () =>
          import('@/pages/demo/charts/list/line/demo1/index.vue'),
        meta: { ...meta, title: '折线图示例 1' }
      },
      {
        path: 'list/line/demo2',
        name: `${pre}list-line-demo2`,
        component: () =>
          import('@/pages/demo/charts/list/line/demo2/index.vue'),
        meta: { ...meta, title: '折线图示例 2' }
      },
      {
        path: 'list/line/demo3',
        name: `${pre}list-line-demo3`,
        component: () =>
          import('@/pages/demo/charts/list/line/demo3/index.vue'),
        meta: { ...meta, title: '折线图示例 3' }
      },
      {
        path: 'list/line/demo4',
        name: `${pre}list-line-demo4`,
        component: () =>
          import('@/pages/demo/charts/list/line/demo4/index.vue'),
        meta: { ...meta, title: '折线图示例 4' }
      },
      {
        path: 'list/line/demo5',
        name: `${pre}list-line-demo5`,
        component: () =>
          import('@/pages/demo/charts/list/line/demo5/index.vue'),
        meta: { ...meta, title: '折线图示例 5' }
      },
      {
        path: 'list/histogram/demo1',
        name: `${pre}list-histogram-demo1`,
        component: () =>
          import('@/pages/demo/charts/list/histogram/demo1/index.vue'),
        meta: { ...meta, title: '柱状图示例 1' }
      },
      {
        path: 'list/histogram/demo2',
        name: `${pre}list-histogram-demo2`,
        component: () =>
          import('@/pages/demo/charts/list/histogram/demo2/index.vue'),
        meta: { ...meta, title: '柱状图示例 2' }
      },
      {
        path: 'list/histogram/demo3',
        name: `${pre}list-histogram-demo3`,
        component: () =>
          import('@/pages/demo/charts/list/histogram/demo3/index.vue'),
        meta: { ...meta, title: '柱状图示例 3' }
      },
      {
        path: 'list/histogram/demo4',
        name: `${pre}list-histogram-demo4`,
        component: () =>
          import('@/pages/demo/charts/list/histogram/demo4/index.vue'),
        meta: { ...meta, title: '柱状图示例 4' }
      },
      {
        path: 'list/histogram/demo5',
        name: `${pre}list-histogram-demo5`,
        component: () =>
          import('@/pages/demo/charts/list/histogram/demo5/index.vue'),
        meta: { ...meta, title: '柱状图示例 5' }
      },
      {
        path: 'list/histogram/demo6',
        name: `${pre}list-histogram-demo6`,
        component: () =>
          import('@/pages/demo/charts/list/histogram/demo6/index.vue'),
        meta: { ...meta, title: '柱状图示例 6' }
      },
      {
        path: 'list/bar/demo1',
        name: `${pre}list-bar-demo1`,
        component: () => import('@/pages/demo/charts/list/bar/demo1/index.vue'),
        meta: { ...meta, title: '条形图示例 1' }
      },
      {
        path: 'list/bar/demo2',
        name: `${pre}list-bar-demo2`,
        component: () => import('@/pages/demo/charts/list/bar/demo2/index.vue'),
        meta: { ...meta, title: '条形图示例 2' }
      },
      {
        path: 'list/bar/demo3',
        name: `${pre}list-bar-demo3`,
        component: () => import('@/pages/demo/charts/list/bar/demo3/index.vue'),
        meta: { ...meta, title: '条形图示例 3' }
      },
      {
        path: 'list/bar/demo4',
        name: `${pre}list-bar-demo4`,
        component: () => import('@/pages/demo/charts/list/bar/demo4/index.vue'),
        meta: { ...meta, title: '条形图示例 4' }
      },
      {
        path: 'list/bar/demo5',
        name: `${pre}list-bar-demo5`,
        component: () => import('@/pages/demo/charts/list/bar/demo5/index.vue'),
        meta: { ...meta, title: '条形图示例 5' }
      },
      {
        path: 'list/pie/demo1',
        name: `${pre}list-pie-demo1`,
        component: () => import('@/pages/demo/charts/list/pie/demo1/index.vue'),
        meta: { ...meta, title: '饼图示例 1' }
      },
      {
        path: 'list/pie/demo2',
        name: `${pre}list-pie-demo2`,
        component: () => import('@/pages/demo/charts/list/pie/demo2/index.vue'),
        meta: { ...meta, title: '饼图示例 2' }
      },
      {
        path: 'list/pie/demo3',
        name: `${pre}list-pie-demo3`,
        component: () => import('@/pages/demo/charts/list/pie/demo3/index.vue'),
        meta: { ...meta, title: '饼图示例 3' }
      },
      {
        path: 'list/pie/demo4',
        name: `${pre}list-pie-demo4`,
        component: () => import('@/pages/demo/charts/list/pie/demo4/index.vue'),
        meta: { ...meta, title: '饼图示例 4' }
      },
      {
        path: 'list/pie/demo5',
        name: `${pre}list-pie-demo5`,
        component: () => import('@/pages/demo/charts/list/pie/demo5/index.vue'),
        meta: { ...meta, title: '饼图示例 5' }
      },
      {
        path: 'list/pie/demo6',
        name: `${pre}list-pie-demo6`,
        component: () => import('@/pages/demo/charts/list/pie/demo6/index.vue'),
        meta: { ...meta, title: '饼图示例 6' }
      },
      {
        path: 'list/ring/demo1',
        name: `${pre}list-ring-demo1`,
        component: () =>
          import('@/pages/demo/charts/list/ring/demo1/index.vue'),
        meta: { ...meta, title: '环图示例 1' }
      },
      {
        path: 'list/ring/demo2',
        name: `${pre}list-ring-demo2`,
        component: () =>
          import('@/pages/demo/charts/list/ring/demo2/index.vue'),
        meta: { ...meta, title: '环图示例 2' }
      },
      {
        path: 'list/ring/demo3',
        name: `${pre}list-ring-demo3`,
        component: () =>
          import('@/pages/demo/charts/list/ring/demo3/index.vue'),
        meta: { ...meta, title: '环图示例 3' }
      },
      {
        path: 'list/ring/demo4',
        name: `${pre}list-ring-demo4`,
        component: () =>
          import('@/pages/demo/charts/list/ring/demo4/index.vue'),
        meta: { ...meta, title: '环图示例 4' }
      },
      {
        path: 'list/ring/demo5',
        name: `${pre}list-ring-demo5`,
        component: () =>
          import('@/pages/demo/charts/list/ring/demo5/index.vue'),
        meta: { ...meta, title: '环图示例 5' }
      },
      {
        path: 'list/waterfall/demo1',
        name: `${pre}list-waterfall-demo1`,
        component: () =>
          import('@/pages/demo/charts/list/waterfall/demo1/index.vue'),
        meta: { ...meta, title: '瀑布图示例 1' }
      },
      {
        path: 'list/funnel/demo1',
        name: `${pre}list-funnel-demo1`,
        component: () =>
          import('@/pages/demo/charts/list/funnel/demo1/index.vue'),
        meta: { ...meta, title: '漏斗图示例 1' }
      },
      {
        path: 'list/funnel/demo2',
        name: `${pre}list-funnel-demo2`,
        component: () =>
          import('@/pages/demo/charts/list/funnel/demo2/index.vue'),
        meta: { ...meta, title: '漏斗图示例 2' }
      },
      {
        path: 'list/radar/demo1',
        name: `${pre}list-radar-demo1`,
        component: () =>
          import('@/pages/demo/charts/list/radar/demo1/index.vue'),
        meta: { ...meta, title: '雷达图示例 1' }
      },
      {
        path: 'list/map/demo1',
        name: `${pre}list-map-demo1`,
        component: () => import('@/pages/demo/charts/list/map/demo1/index.vue'),
        meta: { ...meta, title: '地图示例 1' }
      },
      {
        path: 'list/map/demo2',
        name: `${pre}list-map-demo2`,
        component: () => import('@/pages/demo/charts/list/map/demo2/index.vue'),
        meta: { ...meta, title: '地图示例 2' }
      },
      {
        path: 'list/map/demo3',
        name: `${pre}list-map-demo3`,
        component: () => import('@/pages/demo/charts/list/map/demo3/index.vue'),
        meta: { ...meta, title: '地图示例 3' }
      },
      {
        path: 'list/sankey/demo1',
        name: `${pre}list-sankey-demo1`,
        component: () =>
          import('@/pages/demo/charts/list/sankey/demo1/index.vue'),
        meta: { ...meta, title: '桑基图示例 1' }
      },
      {
        path: 'list/heatmap/demo1',
        name: `${pre}list-heatmap-demo1`,
        component: () =>
          import('@/pages/demo/charts/list/heatmap/demo1/index.vue'),
        meta: { ...meta, title: '热力图示例 1' }
      },
      {
        path: 'list/heatmap/demo2',
        name: `${pre}list-heatmap-demo2`,
        component: () =>
          import('@/pages/demo/charts/list/heatmap/demo2/index.vue'),
        meta: { ...meta, title: '热力图示例 2' }
      },
      {
        path: 'list/scatter/demo1',
        name: `${pre}list-scatter-demo1`,
        component: () =>
          import('@/pages/demo/charts/list/scatter/demo1/index.vue'),
        meta: { ...meta, title: '散点图示例 1' }
      },
      {
        path: 'list/scatter/demo2',
        name: `${pre}list-scatter-demo2`,
        component: () =>
          import('@/pages/demo/charts/list/scatter/demo2/index.vue'),
        meta: { ...meta, title: '散点图示例 2' }
      },
      {
        path: 'list/candle/demo1',
        name: `${pre}list-candle-demo1`,
        component: () =>
          import('@/pages/demo/charts/list/candle/demo1/index.vue'),
        meta: { ...meta, title: 'K线图示例 1' }
      },
      {
        path: 'list/candle/demo2',
        name: `${pre}list-candle-demo2`,
        component: () =>
          import('@/pages/demo/charts/list/candle/demo2/index.vue'),
        meta: { ...meta, title: 'K线图示例 2' }
      },
      {
        path: 'list/candle/demo3',
        name: `${pre}list-candle-demo3`,
        component: () =>
          import('@/pages/demo/charts/list/candle/demo3/index.vue'),
        meta: { ...meta, title: 'K线图示例 3' }
      },
      {
        path: 'list/gauge/demo1',
        name: `${pre}list-gauge-demo1`,
        component: () =>
          import('@/pages/demo/charts/list/gauge/demo1/index.vue'),
        meta: { ...meta, title: '仪表盘示例 1' }
      },
      {
        path: 'list/tree/demo1',
        name: `${pre}list-tree-demo1`,
        component: () =>
          import('@/pages/demo/charts/list/tree/demo1/index.vue'),
        meta: { ...meta, title: '树图示例 1' }
      }
    ])('demo-charts-')
  },
  {
    path: '/demo/components',
    name: 'demo-components',
    meta,
    redirect: { name: 'demo-components-index' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'container/full',
        name: `${pre}container-full`,
        component: () => import('@/pages/demo/components/container/full.vue'),
        meta: { ...meta, title: '布局组件 填充' }
      },
      {
        path: 'container/full-slot',
        name: `${pre}container-full-slot`,
        component: () =>
          import('@/pages/demo/components/container/full-slot.vue'),
        meta: { ...meta, title: '布局组件 填充 插槽' }
      },
      {
        path: 'container/full-bs',
        name: `${pre}container-full-bs`,
        component: () =>
          import('@/pages/demo/components/container/full-bs.vue'),
        meta: { ...meta, title: '布局组件 填充 滚动优化' }
      },
      {
        path: 'container/ghost',
        name: `${pre}container-ghost`,
        component: () => import('@/pages/demo/components/container/ghost.vue'),
        meta: { ...meta, title: '布局组件 隐形' }
      },
      {
        path: 'container/ghost-slot',
        name: `${pre}container-ghost-slot`,
        component: () =>
          import('@/pages/demo/components/container/ghost-slot.vue'),
        meta: { ...meta, title: '布局组件 隐形 插槽' }
      },
      {
        path: 'container/ghost-bs',
        name: `${pre}container-ghost-bs`,
        component: () =>
          import('@/pages/demo/components/container/ghost-bs.vue'),
        meta: { ...meta, title: '布局组件 隐形 滚动优化' }
      },
      {
        path: 'container/card',
        name: `${pre}container-card`,
        component: () => import('@/pages/demo/components/container/card.vue'),
        meta: { ...meta, title: '布局组件 卡片' }
      },
      {
        path: 'container/card-slot',
        name: `${pre}container-card-slot`,
        component: () =>
          import('@/pages/demo/components/container/card-slot.vue'),
        meta: { ...meta, title: '布局组件 卡片 插槽' }
      },
      {
        path: 'container/card-bs',
        name: `${pre}container-card-bs`,
        component: () =>
          import('@/pages/demo/components/container/card-bs.vue'),
        meta: { ...meta, title: '布局组件 卡片 滚动优化' }
      },
      {
        path: 'contextmenu/simple',
        name: `${pre}contextmenu-simple`,
        component: () =>
          import('@/pages/demo/components/contextmenu/simple.vue'),
        meta: { ...meta, title: '右键菜单 基础' }
      },
      {
        path: 'contextmenu/divier',
        name: `${pre}contextmenu-divier`,
        component: () =>
          import('@/pages/demo/components/contextmenu/divier.vue'),
        meta: { ...meta, title: '右键菜单 分割线' }
      },
      {
        path: 'contextmenu/group',
        name: `${pre}contextmenu-group`,
        component: () =>
          import('@/pages/demo/components/contextmenu/group.vue'),
        meta: { ...meta, title: '右键菜单 分组' }
      },
      {
        path: 'contextmenu/submenu',
        name: `${pre}contextmenu-submenu`,
        component: () =>
          import('@/pages/demo/components/contextmenu/submenu.vue'),
        meta: { ...meta, title: '右键菜单 子菜单' }
      },
      {
        path: 'contextmenu/disabled',
        name: `${pre}contextmenu-disabled`,
        component: () =>
          import('@/pages/demo/components/contextmenu/disabled.vue'),
        meta: { ...meta, title: '右键菜单 禁用' }
      },
      {
        path: 'contextmenu/custom-trigger',
        name: `${pre}contextmenu-custom-trigger`,
        component: () =>
          import('@/pages/demo/components/contextmenu/custom-trigger.vue'),
        meta: { ...meta, title: '右键菜单 自定义触发' }
      },
      {
        path: 'countup',
        name: `${pre}countup`,
        component: () => import('@/pages/demo/components/countup'),
        meta: { ...meta, title: '数字动画' }
      },
      {
        path: 'editor-quill',
        name: `${pre}editor-quill`,
        component: () => import('@/pages/demo/components/editor-quill'),
        meta: { ...meta, title: '富文本编辑器' }
      },
      {
        path: 'editor-simpleMDE',
        name: `${pre}editor-simpleMDE`,
        component: () => import('@/pages/demo/components/editor-simpleMDE'),
        meta: { ...meta, title: 'markdown编辑器' }
      },
      {
        path: 'highlight',
        name: `${pre}highlight`,
        component: () => import('@/pages/demo/components/highlight'),
        meta: { ...meta, title: '代码高亮组件' }
      },
      {
        path: 'icon/icon',
        name: `${pre}icon-icon`,
        component: () => import('@/pages/demo/components/icon/icon.vue'),
        meta: { ...meta, title: '图标组件' }
      },
      {
        path: 'icon/list',
        name: `${pre}icon-list`,
        component: () => import('@/pages/demo/components/icon/list.vue'),
        meta: { ...meta, title: '图标列表' }
      },
      {
        path: 'icon/select',
        name: `${pre}icon-select`,
        component: () => import('@/pages/demo/components/icon/select.vue'),
        meta: { ...meta, title: '图表选择器组件' }
      },
      {
        path: 'icon/svg',
        name: `${pre}icon-svg`,
        component: () => import('@/pages/demo/components/icon/svg.vue'),
        meta: { ...meta, title: 'svg 图标' }
      },
      {
        path: 'index',
        name: `${pre}index`,
        component: () => import('@/pages/demo/components/index'),
        meta: { ...meta, title: '组件首页' }
      },
      {
        path: 'json-tree',
        name: `${pre}json-tree`,
        component: () => import('@/pages/demo/components/json-tree'),
        meta: { ...meta, title: 'JSON 展示' }
      },
      {
        path: 'layout/grid',
        name: `${pre}layout-grid`,
        component: () => import('@/pages/demo/components/layout/grid.vue'),
        meta: { ...meta, title: '拖拽网格布局' }
      },
      {
        path: 'layout/splitpane',
        name: `${pre}layout-splitpane`,
        component: () => import('@/pages/demo/components/layout/splitpane.vue'),
        meta: { ...meta, title: '区域布局' }
      },
      {
        path: 'markdown/source',
        name: `${pre}markdown-source`,
        component: () => import('@/pages/demo/components/markdown/source.vue'),
        meta: { ...meta, title: 'markdown指定资源渲染' }
      },
      {
        path: 'markdown/url',
        name: `${pre}markdown-url`,
        component: () => import('@/pages/demo/components/markdown/url.vue'),
        meta: { ...meta, title: 'markdown指定url渲染' }
      }
    ])('demo-components-')
  },
  {
    path: '/demo/element',
    name: 'demo-element',
    meta,
    redirect: { name: 'demo-element-index' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'basic-layout',
        name: `${pre}basic-layout`,
        component: () => import('@/pages/demo/element/basic-layout'),
        meta: { ...meta, title: 'Element 布局' }
      },
      {
        path: 'basic-container',
        name: `${pre}basic-container`,
        component: () => import('@/pages/demo/element/basic-container'),
        meta: { ...meta, title: 'Element 布局容器' }
      },
      {
        path: 'basic-color',
        name: `${pre}basic-color`,
        component: () => import('@/pages/demo/element/basic-color'),
        meta: { ...meta, title: 'Element 色彩' }
      },
      {
        path: 'basic-typography',
        name: `${pre}basic-typography`,
        component: () => import('@/pages/demo/element/basic-typography'),
        meta: { ...meta, title: 'Element 字体' }
      },
      {
        path: 'basic-icon',
        name: `${pre}basic-icon`,
        component: () => import('@/pages/demo/element/basic-icon'),
        meta: { ...meta, title: 'Element 图标' }
      },
      {
        path: 'basic-button',
        name: `${pre}basic-button`,
        component: () => import('@/pages/demo/element/basic-button'),
        meta: { ...meta, title: 'Element 按钮' }
      },
      {
        path: 'form-radio',
        name: `${pre}form-radio`,
        component: () => import('@/pages/demo/element/form-radio'),
        meta: { ...meta, title: 'Element 单选框' }
      },
      {
        path: 'form-checkbox',
        name: `${pre}form-checkbox`,
        component: () => import('@/pages/demo/element/form-checkbox'),
        meta: { ...meta, title: 'Element 多选框' }
      },
      {
        path: 'form-input',
        name: `${pre}form-input`,
        component: () => import('@/pages/demo/element/form-input'),
        meta: { ...meta, title: 'Element 输入框' }
      },
      {
        path: 'form-input-number',
        name: `${pre}form-input-number`,
        component: () => import('@/pages/demo/element/form-input-number'),
        meta: { ...meta, title: 'Element 计数器' }
      },
      {
        path: 'form-select',
        name: `${pre}form-select`,
        component: () => import('@/pages/demo/element/form-select'),
        meta: { ...meta, title: 'Element 选择器' }
      },
      {
        path: 'form-cascader',
        name: `${pre}form-cascader`,
        component: () => import('@/pages/demo/element/form-cascader'),
        meta: { ...meta, title: 'Element 级联选择器' }
      },
      {
        path: 'form-switch',
        name: `${pre}form-switch`,
        component: () => import('@/pages/demo/element/form-switch'),
        meta: { ...meta, title: 'Element 开关' }
      },
      {
        path: 'form-slider',
        name: `${pre}form-slider`,
        component: () => import('@/pages/demo/element/form-slider'),
        meta: { ...meta, title: 'Element 滑块' }
      },
      {
        path: 'form-time-picker',
        name: `${pre}form-time-picker`,
        component: () => import('@/pages/demo/element/form-time-picker'),
        meta: { ...meta, title: 'Element 时间选择器' }
      },
      {
        path: 'form-date-picker',
        name: `${pre}form-date-picker`,
        component: () => import('@/pages/demo/element/form-date-picker'),
        meta: { ...meta, title: 'Element 日期选择器' }
      },
      {
        path: 'form-datetime-picker',
        name: `${pre}form-datetime-picker`,
        component: () => import('@/pages/demo/element/form-datetime-picker'),
        meta: { ...meta, title: 'Element 时间日期选择器' }
      },
      {
        path: 'form-upload',
        name: `${pre}form-upload`,
        component: () => import('@/pages/demo/element/form-upload'),
        meta: { ...meta, title: 'Element 上传' }
      },
      {
        path: 'form-rate',
        name: `${pre}form-rate`,
        component: () => import('@/pages/demo/element/form-rate'),
        meta: { ...meta, title: 'Element 评分' }
      },
      {
        path: 'form-color-picker',
        name: `${pre}form-color-picker`,
        component: () => import('@/pages/demo/element/form-color-picker'),
        meta: { ...meta, title: 'Element 颜色选择器' }
      },
      {
        path: 'form-transfer',
        name: `${pre}form-transfer`,
        component: () => import('@/pages/demo/element/form-transfer'),
        meta: { ...meta, title: 'Element 穿梭框' }
      },
      {
        path: 'form-form',
        name: `${pre}form-form`,
        component: () => import('@/pages/demo/element/form-form'),
        meta: { ...meta, title: 'Element 表单' }
      },
      {
        path: 'data-table',
        name: `${pre}data-table`,
        component: () => import('@/pages/demo/element/data-table'),
        meta: { ...meta, title: 'Element 表格' }
      },
      {
        path: 'data-tag',
        name: `${pre}data-tag`,
        component: () => import('@/pages/demo/element/data-tag'),
        meta: { ...meta, title: 'Element 标签' }
      },
      {
        path: 'data-progress',
        name: `${pre}data-progress`,
        component: () => import('@/pages/demo/element/data-progress'),
        meta: { ...meta, title: 'Element 进度条' }
      },
      {
        path: 'data-tree',
        name: `${pre}data-tree`,
        component: () => import('@/pages/demo/element/data-tree'),
        meta: { ...meta, title: 'Element 树形控件' }
      },
      {
        path: 'data-pagination',
        name: `${pre}data-pagination`,
        component: () => import('@/pages/demo/element/data-pagination'),
        meta: { ...meta, title: 'Element 分页' }
      },
      {
        path: 'data-badge',
        name: `${pre}data-badge`,
        component: () => import('@/pages/demo/element/data-badge'),
        meta: { ...meta, title: 'Element 标记' }
      },
      {
        path: 'notice-alert',
        name: `${pre}notice-alert`,
        component: () => import('@/pages/demo/element/notice-alert'),
        meta: { ...meta, title: 'Element 警告' }
      },
      {
        path: 'notice-loading',
        name: `${pre}notice-loading`,
        component: () => import('@/pages/demo/element/notice-loading'),
        meta: { ...meta, title: 'Element 加载' }
      },
      {
        path: 'notice-message',
        name: `${pre}notice-message`,
        component: () => import('@/pages/demo/element/notice-message'),
        meta: { ...meta, title: 'Element 消息提示' }
      },
      {
        path: 'notice-message-box',
        name: `${pre}notice-message-box`,
        component: () => import('@/pages/demo/element/notice-message-box'),
        meta: { ...meta, title: 'Element 弹框' }
      },
      {
        path: 'notice-notification',
        name: `${pre}notice-notification`,
        component: () => import('@/pages/demo/element/notice-notification'),
        meta: { ...meta, title: 'Element 通知' }
      },
      {
        path: 'navigation-menu',
        name: `${pre}navigation-menu`,
        component: () => import('@/pages/demo/element/navigation-menu'),
        meta: { ...meta, title: 'Element 导航菜单' }
      },
      {
        path: 'navigation-tabs',
        name: `${pre}navigation-tabs`,
        component: () => import('@/pages/demo/element/navigation-tabs'),
        meta: { ...meta, title: 'Element 标签页' }
      },
      {
        path: 'navigation-breadcrumb',
        name: `${pre}navigation-breadcrumb`,
        component: () => import('@/pages/demo/element/navigation-breadcrumb'),
        meta: { ...meta, title: 'Element 面包屑' }
      },
      {
        path: 'navigation-dropdown',
        name: `${pre}navigation-dropdown`,
        component: () => import('@/pages/demo/element/navigation-dropdown'),
        meta: { ...meta, title: 'Element 下拉菜单' }
      },
      {
        path: 'navigation-steps',
        name: `${pre}navigation-steps`,
        component: () => import('@/pages/demo/element/navigation-steps'),
        meta: { ...meta, title: 'Element 步骤条' }
      },
      {
        path: 'others-dialog',
        name: `${pre}others-dialog`,
        component: () => import('@/pages/demo/element/others-dialog'),
        meta: { ...meta, title: 'Element 对话框' }
      },
      {
        path: 'others-tooltip',
        name: `${pre}others-tooltip`,
        component: () => import('@/pages/demo/element/others-tooltip'),
        meta: { ...meta, title: 'Element 文字提示' }
      },
      {
        path: 'others-popover',
        name: `${pre}others-popover`,
        component: () => import('@/pages/demo/element/others-popover'),
        meta: { ...meta, title: 'Element 弹出框' }
      },
      {
        path: 'others-card',
        name: `${pre}others-card`,
        component: () => import('@/pages/demo/element/others-card'),
        meta: { ...meta, title: 'Element 卡片' }
      },
      {
        path: 'others-carousel',
        name: `${pre}others-carousel`,
        component: () => import('@/pages/demo/element/others-carousel'),
        meta: { ...meta, title: 'Element 走马灯' }
      },
      {
        path: 'others-collapse',
        name: `${pre}others-collapse`,
        component: () => import('@/pages/demo/element/others-collapse'),
        meta: { ...meta, title: 'Element 折叠面板' }
      },
      {
        path: 'index',
        name: `${pre}index`,
        component: () => import('@/pages/demo/element/index'),
        meta: { ...meta, title: 'ElementUI' }
      }
    ])('demo-element-')
  },
  {
    path: '/demo/business',
    name: 'demo-business',
    meta,
    redirect: { name: 'demo-business-index' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'table/1',
        name: `${pre}index`,
        component: () => import('@/pages/demo/business/table/1'),
        meta: { ...meta, title: 'Demo' }
      }
      // { path: 'table/1', name: `${pre}table-1`, component: () => import('@/pages/demo/business/table/1'), meta: { ...meta, title: '表格 1' } }
    ])('demo-business-')
  },
  {
    path: '/mb',
    name: 'mb',
    meta,
    redirect: { name: 'mb-member' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'member',
        name: `${pre}member`,
        component: () => import('@/pages/mb/member/'),
        meta: { ...meta, title: '会员列表' }
      },
      {
        path: 'upgradesetting',
        name: `${pre}upgradesetting`,
        component: () => import('@/pages/mb/upgradesetting/'),
        meta: { ...meta, title: '晋级设置' }
      },
      {
        path: 'club',
        name: `${pre}club`,
        component: () => import('@/pages/mb/club/'),
        meta: { ...meta, title: '转会管理' }
      },
      {
        path: 'game',
        name: `${pre}game`,
        component: () => import('@/pages/mb/game/'),
        meta: { ...meta, title: '比赛列表' }
      },
      {
        path: 'mbPromotion',
        name: `${pre}mbPromotion`,
        component: () => import('@/pages/mb/mbPromotion/'),
        meta: { ...meta, title: '升级名单' }
      },
      {
        path: 'mbLevelAdjust',
        name: `${pre}mbLevelAdjust`,
        component: () => import('@/pages/mb/mbLevelAdjust/'),
        meta: { ...meta, title: '级别调整记录' }
      },
    ])('mb-')
  },
  // 竞赛
  {
    path: '/ct/competition',
    name: 'ct-competition',
    meta,
    redirect: { name: 'ct-competition-level' },
    component: layoutHeaderAside,
    children: (pre => [
      {
        path: 'teenagers',
        name: `${pre}teenagers`,
        component: () => import('@/pages/ct/competition/teenagers/'),
        meta: { ...meta, title: '青少年比赛' }
      },
      {
        path: 'level',
        name: `${pre}level`,
        component: () => import('@/pages/ct/competition/level/'),
        meta: { ...meta, title: '分级公开赛' }
      },
      {
        path: 'free',
        name: `${pre}free`,
        component: () => import('@/pages/ct/competition/free/'),
        meta: { ...meta, title: '自选比赛' }
      },
      {
        path: 'club',
        name: `${pre}club`,
        component: () => import('@/pages/ct/competition/club/'),
        meta: { ...meta, title: '俱乐部公开赛' }
      },
      {
        path: 'micro',
        name: `${pre}micro`,
        component: () => import('@/pages/ct/competition/micro/'),
        meta: { ...meta, title: '自助约赛' }  //原微赛事
      },

      {
        path: 'feesetting',
        name: `${pre}feesetting`,
        component: () => import('@/pages/ct/competition/feesetting/'),
        meta: { ...meta, title: '费用设置' }  
      },
      {
        path: 'regulation',
        name: `${pre}regulation`,
        component: () => import('@/pages/ct/competition/regulation/'),
        meta: { ...meta, title: '规程管理' }
      },
      {
        path: 'referee',
        name: `${pre}referee`,
        component: () => import('@/pages/ct/competition/referee/'),
        meta: { ...meta, title: '裁判管理' }
      },
      {
        path: 'clubManage/clubList',
        name: `${pre}clubList`,
        component: () => import('@/pages/ct/competition/clubManage/clubList'),
        meta: { ...meta, title: '俱乐部列表' }
      },
      {
        path: 'clubManage/registerList',
        name: `${pre}registerList`,
        component: () =>
          import('@/pages/ct/competition/clubManage/registerList'),
        meta: { ...meta, title: '注册申请列表' }
      },
      {
        path: 'clubManage/renameList',
        name: `${pre}renameList`,
        component: () => import('@/pages/ct/competition/clubManage/renameList'),
        meta: { ...meta, title: '注册申请列表' }
      }
    ])('ct-competition-')
  }
];

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 页面重定向使用 必须保留
  {
    path: '/redirect/:path*',
    component: () => import('@/pages/redirect')
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login')
  }
];

/**
 * 错误页面
 */
const errorPage = [
  // 404
  {
    path: '*',
    name: '404',
    component: () => import('@/pages/error-page-404')
  }
];

// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 重新组织后导出
export default [...frameIn, ...frameOut, ...errorPage];